/** Docs (UA): see modules/game/DOCS.md — game reward accrual.
 *
 *  Decision (21.08): the game point goes through the SAME loyalty /write-on
 *  as the purchase point, proxied by our BFF. Idempotency is server-side since
 *  SWRN-1887: the BFF sends `Idempotency-Key: write-on:game:{orderId}`, so a
 *  repeated or parallel accrual for the same order gets the first result
 *  instead of a second point. The one-try-per-order in useGameTry stays as a
 *  UX frame, not as the protection.
 */

import { apiClient } from '../../../shared/lib/apiClient';

export interface GameRewardRequestDto {
    orderId: number;
    loyaltyId: number;
    userId: number;
}

/** The loyalty `/api/write-on` response, forwarded verbatim by the BFF. */
export interface GameRewardResponse {
    loyalty_operation_id: number;
    new_balance: number;
    user_id: number;
    loyalty_id: number;
    loyalty_config_id: number;
    points_accrued: number;
}

export async function accrueGameReward(
    dto: GameRewardRequestDto,
): Promise<GameRewardResponse | null> {
    try {
        const { data } = await apiClient.post<GameRewardResponse>('/api/game/reward', dto);
        return data;
    } catch {
        // Client is the source of truth (design frame): the win screen stays
        // optimistic; a failed accrual must not spoil the gift moment. `null`
        // also means «leave the shown balance alone» — never invent a point.
        return null;
    }
}
